import React, { useState, useEffect, useRef, useMemo } from 'react';
import api from './AxiosConfig';
import date from 'date-and-time'; // Moved import to top
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

//===============================================================
function ReviewGoalRM(props) {
  const [progress,       setProgress]         = useState([]);
  const [progressLoaded, setProgressLoaded]   = useState(false);
  const [sgLoaded,       setSGLoaded]         = useState(false);
  const [subGoalItems,   setSubGoalItems]     = useState( [] );
  const colorsList = [
    {r: 255, g: 0,   b: 0 },
    {r: 0,   g: 0,   b: 255 },
    {r: 0,   g: 255, b: 0 },
    {r: 255, g: 127, b: 0 },
    {r: 0,   g: 127, b: 255 },
    {r: 0,   g: 255, b: 127 },
    {r: 255, g: 127, b: 127 },
    {r: 127, g: 127, b: 255 },
    {r: 127, g: 255, b: 127 },
  ];

  useEffect(() => {
      async function getSubGoalItems() {
          if ( props?.goal?.id && !sgLoaded ) {
              try {
                  const response = await api.get(`/site/radar-goals/${encodeURIComponent(props.goal.id)}`, {withCredentials: true });
                  setSubGoalItems(response.data);
                  setSGLoaded(true);
              } catch (error) {
                  console.log("getSubGoalItems: " + error);
              }
          }
      }
      // Fetch the progress record for this goal.
      getSubGoalItems();
  }, [sgLoaded, props.goal?.id]); 

  useEffect(() => {
    const getGoalProgress = async () => {
      if ( sgLoaded === true && progressLoaded === false ) {
        try {
          var cumProgress = [];
          for ( let sg = 0; sg < subGoalItems.length ; sg++ ) {
              const goalProgress = await api.get(`/site/radar-goals-progress/current/${encodeURIComponent(subGoalItems[sg].id)}`, { withCredentials: true });
              cumProgress.push(goalProgress.data);
          }
          console.log("cumProgress=" + JSON.stringify(cumProgress));
          setProgress(cumProgress);
          setProgressLoaded(true);
        } catch (error) {
          console.log("ReviewGoalRM: " + error);
        }
      }
    };
    getGoalProgress();
  }, [sgLoaded, progressLoaded]); // Narrowed deps for efficiency

  // Format date for date form control.
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  
  function calcScore(start, target, value) {
     if ( start < target ) {
         return ( 100.0 * (value - start)/(target - start)  );
     } else {
         return ( 100.0 * (start - value)/(start - target) );
     }
  }
  

  // Generate the Radar Plot
// Register the required components
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

var theLabels = [];  
let summary = [];
for ( let i = 0; i < subGoalItems.length ; i++) {
   theLabels.push(subGoalItems[i].name);
   let summaryLine = subGoalItems[i].name + ": (" + subGoalItems[i].start +", " +  subGoalItems[i].target + " ) "; 
   if (subGoalItems[i].description !== null) {
       summaryLine = summaryLine + subGoalItems[i].description;
   }
   summary.push(  summaryLine );
   console.log("Dataset = " + subGoalItems[i].name );
}

var theDataSets = [];
if ( progress.length > 0 ) {
    for ( let p = 0; p < progress[0].length ; p++ ) {
        var theDate = formatDate(progress[0][p].date);
        var theData = [];
        for ( let g = 0; g < progress.length ; g++ ) {
            theData.push( calcScore(subGoalItems[g].start, subGoalItems[g].target, progress[g][p].value) );
        }
        const colorIndex = p % colorsList.length;
        const rgbString  = "rgb(" + colorsList[colorIndex].r + "," +  colorsList[colorIndex].g + "," + colorsList[colorIndex].b + ")";
        const rgbaString = "rgb(" + colorsList[colorIndex].r + "," +  colorsList[colorIndex].g + "," + colorsList[colorIndex].b + ",0.2)";
        var theDataSet = {
            label: theDate,
            data: theData,
            backgroundColor: rgbaString,
            borderColor: rgbaString,
            pointBackgroundColor: rgbString,
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: rgbString,
        }
        theDataSets.push(theDataSet);
    }
}
  
console.log("theLabels = " + JSON.stringify(theLabels));
const data = {
  labels: theLabels,
  datasets: theDataSets
};
        
const options = {
  responsive: true,
  scales: {
    r: {
      beginAtZero: true,
      max: 100,
      ticks: {
        stepSize: 20,
      },
    },
  },
};

return (
    <div>
      {progressLoaded ? (
        <>
          <div style={{ maxWidth: 600, margin: '0 auto' }}>
             <div className="dqt-summary">{summary.map ((item) => ( <div>{item}</div> ))}</div>
             <Radar data={data} options={options} />
          </div>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ReviewGoalRM;
